import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Colors } from '../../theme';

export const DialogTitle = styled(Typography)(() => ({
  color: Colors.PURPLE_MEDIUM,
  fontSize: '1.5rem',
  fontWeight: 'bold',
  margin: '0.5rem',
  position: 'relative',
  top: '20px',
  paddingLeft: '1rem',
  paddingRight: '1rem',
}));

export const DialogSubTitle = styled(Typography)(() => ({
  color: Colors.PURPLE_LIGHT,
  fontSize: '1.1rem',
  fontWeight: 'normal',
  margin: '0.5rem',
  position: 'relative',
  bottom: '5px',
}));
export const ButtonContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  height: '50px',
}));

export const MainDialogButton = styled(Button)((props) => ({
  background: Colors.GREEN_BACKGROUND,
  width: props.width,
  color: Colors.BG_START,
  margin: '0',
  borderRadius: 'unset',
  fontWeight: 'bold',
  '&:hover': {
    background: Colors.GREEN_BACKGROUND,
  },
}));

export const SecondaryDialogButton = styled(Button)(() => ({
  width: '50%',
  borderRadius: 'unset',
  background: Colors.WHITE,
  color: Colors.GRAY_BACKGROUND_MODAL,
  fontWeight: 'bold',
  '&:hover': {
    background: Colors.WHITE,
  },
}));
